import { render } from "./environment-editor.vue?vue&type=template&id=177fe464"
import script from "./environment-editor.vue?vue&type=script&lang=ts"
export * from "./environment-editor.vue?vue&type=script&lang=ts"
script.render = render

export default script